import { useState, useEffect } from 'react';
import { User, Trophy, House } from 'phosphor-react';
import AvatarSelector, { getAvatarIcon } from './AvatarSelector';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { toast } from 'react-toastify';

function MyAccount() {
  const username = localStorage.getItem('username');
  const [selectedAvatar, setSelectedAvatar] = useState('person');
  const [points, setPoints] = useState(0);
  const [displayName, setDisplayName] = useState(username);
  const [isEditingName, setIsEditingName] = useState(false);
  const [userStats, setUserStats] = useState(null);

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const [userData, rankingData] = await Promise.all([
          axios.get(`${API_BASE_URL}/user-data`, { params: { username } }),
          axios.get(`${API_BASE_URL}/ranking/${username}`)  // Updated endpoint
        ]);

        setPoints(userData.data.points || 0);
        setSelectedAvatar(userData.data.avatar || 'person');
        setUserStats({
          ...rankingData.data,
          avatar: userData.data.avatar || 'person'
        });
        setDisplayName(userData.data.display_name);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchAllUserData();
    const interval = setInterval(fetchAllUserData, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, [username]);

  const handleNameSave = () => {
   
    axios.post(`${API_BASE_URL}/update-user`, {
      username,
      displayName
    })
    .then(() => {
      toast.success('Nazwa użytkownika została zaktualizowana');
      setIsEditingName(false);
    })
    .catch(() => {
      toast.error('Wystąpił błąd podczas aktualizacji nazwy użytkownika');
    });
  };

  return (
    <div className="max-w-2xl mx-auto p-4">
      <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
        <div className="flex items-center gap-4 mb-8">
          <User size={48} className="text-blue-400" />
          <div className="flex-1">
            {isEditingName ? (
              <div className="flex gap-2">
                <input
                  type="text"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  className="bg-gray-700 border-gray-600 text-white rounded px-2 py-1"
                />
                <button 
                  onClick={handleNameSave}
                  className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Zapisz
                </button>
                <button 
                  onClick={() => setIsEditingName(false)}
                  className="px-3 py-1 bg-gray-700 text-gray-300 rounded hover:bg-gray-600"
                >
                  Anuluj
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <h1 className="text-2xl font-bold text-white">{displayName}</h1>
                <button 
                  onClick={() => setIsEditingName(true)}
                  className="text-blue-400 hover:text-blue-300 text-sm"
                >
                  Edytuj
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-gray-700/50 border border-gray-600 p-4 rounded-lg">
            <div className="flex items-center gap-3 mb-3">
              {userStats?.avatar && (
                <div className="w-12 h-12 flex items-center justify-center bg-gray-800 rounded-full">
                  {getAvatarIcon(userStats.avatar)}
                </div>
              )}
              <div>
                <div className="text-sm text-blue-400">Twoje punkty</div>
                <div className="text-2xl font-bold text-white">{userStats?.total_points || 0}</div>
              </div>
            </div>
            {userStats && (
              <div className="text-sm text-gray-400 mt-2 flex items-center gap-2">
                <Trophy size={20} className="text-yellow-500" />
                <div>Pozycja w rankingu: {userStats.rank || '-'}</div>
                <div className="text-gray-600">•</div>
                <div>Ukończone zadania: {userStats.completed_tasks || 0}</div>
              </div>
            )}
          </div>
          
          <div>
            <h2 className="text-lg font-semibold mb-4 text-white">Mój awatar</h2>
            <AvatarSelector 
              selectedAvatar={selectedAvatar}
              onSelect={(avatar) => {
                setSelectedAvatar(avatar);
                axios.post(`${API_BASE_URL}/update-user`, {
                  username,
                  avatar
                })
                .then(() => toast.success('Avatar został zaktualizowany'))
                .catch(() => toast.error('Wystąpił błąd podczas aktualizacji avatara'));
              }}
            />
          </div>
          
          <div className="pt-4 border-t border-gray-600">
            <NavLink 
              to="/event-info" 
              className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-md transition-colors w-full"
            >
              <House size={20} />
              O WYDARZENIU
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAccount;
